(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemDeleteController',PurchasePresentItemDeleteController);

    PurchasePresentItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchasePresentItem'];

    function PurchasePresentItemDeleteController($uibModalInstance, entity, PurchasePresentItem) {
        var vm = this;
        vm.purchasePresentItem = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PurchasePresentItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
